<link href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css" rel="stylesheet">


<div class="card sidebar__common">
    <div class="card-body">
        <div class="flex-container">
            <div class="left-column">
                <ul class="list-item">
                    <li *ngFor="let doc of documents" (click)="getDetailWhatNew(doc.id)" class="item" [class.selected]="selectedItemId === doc.id">
                        <div class="font-semibold title">{{ doc.title }}</div>
                      
                    </li>
                </ul> 
             
                  
            </div>
            <div class="right-column">
                <div *ngIf="selectedDocument">
                    <div class="font-semibold title">{{ selectedDocument.title }}</div>
                    <div class="text-gray-500 date">{{selectedDocument.timestamp}}</div>
                    <br/>
                    <div class="details-item" [innerHTML]="selectedDocument.content"></div>
                </div>
            </div>
        </div>
    </div>
</div>
